import { render, staticRenderFns } from "./materialKitRate.vue?vue&type=template&id=2947fac5&scoped=true"
import script from "./materialKitRate.vue?vue&type=script&lang=js"
export * from "./materialKitRate.vue?vue&type=script&lang=js"
import style0 from "./materialKitRate.vue?vue&type=style&index=0&id=2947fac5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2947fac5",
  null
  
)

export default component.exports